module.exports = __webpack_public_path__ + "static/media/PhoneTwo.fdc179d3.png";